<template>
    <card-component :title="`Evaluación juez ${judgeName}`" subtitle="Notas por ejercicio" class="has-table has-mobile-sort-spaced" >
        <div slot="headerRight" class="card-header-icon">
          <div class="buttons">
            <b-button type="is-default" icon-left="cancel" @click="cancel">Cancelar</b-button>
            <b-button type="is-primary" icon-left="content-save" @click="saveChages">Guardar</b-button>
          </div>
        </div>
        <div slot="content">
          <ValidationObserver ref="observer">
            <b-table
              :data="exercises"
              :bordered="true"
              :opened-detailed.sync="defaultOpenedDetails"
              :striped="true"
              :show-detail-icon="true"
              detailed
              :mobile-cards="false"
              class="selected-rows"
              detail-key="id"
              @click="toggleDetails"
              :loading="isLoading" :key="componentKey">

              <template slot-scope="props" slot="header">
                <div>
                  <b-icon
                    v-if="props.column.meta.official"
                    style="margin-left: 0rem;"
                      icon="star"
                      size="is-small">
                  </b-icon>
                  <br>
                  {{ props.column.label }}
                </div>
              </template>

              <template slot-scope="props">
                  <b-table-column label="#" width="40" numeric centered class="'is-sticky-column-one'">
                      {{props.index + 1}}
                  </b-table-column>

                  <b-table-column field="name" label="Ejercicio">
                      {{props.row.name}}
                  </b-table-column>

                  <b-table-column field="score" width="120" label="nota" centered>
                    <ValidationProvider
                        v-if="!props.row.disabled_evaluate"
                        :name="`nota-${props.index + 1}`"
                        :rules="`required|oneOf:${numbers}|max_value:10|min_value:1`"
                        v-slot="{ errors }">
                      <b-field
                        :type="{ 'is-danger': errors[0] }">
                        <b-input v-model="props.row.result.base_score" @blur="calcTotals" @click.native.stop="() => false" step=".01" type="number" min="0"  max="10"> </b-input>
                      </b-field>
                    </ValidationProvider>
                  </b-table-column>

                  <b-table-column field="coeficent" width="50"  label="Coef" centered>
                    <span v-if="!props.row.disabled_evaluate"> {{props.row.coefficient}} </span>
                  </b-table-column>

                  <b-table-column field="subtotal" width="100" label="SubTotal" >
                    <span v-if="!props.row.disabled_evaluate"> {{ props.row.result.base_score * props.row.result.coefficient}} </span>
                  </b-table-column>

                  <b-table-column field="observation" label="Observación" centered>
                    <b-input v-model="props.row.result.observation" @click.native.stop="() => false"> </b-input>
                  </b-table-column>
              </template>

              <template slot="detail" slot-scope="props">
                <p><b>Descripción del Ejercicio</b></p>
                <div>
                    <tr v-for="action_position in props.row.actions_positions" :key="action_position.id">
                        <td>{{action_position.position ? action_position.position.name : ''}}</td>
                        <td>{{action_position.action ? action_position.action.name : ''}}</td>
                    </tr>
                </div>
              </template>

              <template slot="footer" v-if="!isLoading && exercises.length > 0">
                  <th class="" style="">
                  </th>
                  <th class="" style="">
                  </th>
                  <th class="" style="">
                  </th>
                  <th class="" style="">
                  </th>
                  <th class="" >
                      <div class="th-wrap is-numeric"> Subtotal <br> Errores <br> Totales <br> Nota </div>
                  </th>
                  <th class="" style="width:40px">
                      <div class="th-wrap"><p >{{ subTotal }}</p> <span class="ft-labels">pts</span> </div>
                      <div class="th-wrap"><p >{{ exerciseErrors }}</p> <span class="ft-labels">pts</span> </div>
                      <div class="th-wrap"><p >{{ total }}</p> <span class="ft-labels">pts</span> </div>

                      <div class="th-wrap"><h1 class="title is-5 ">{{ finalScore.toFixed(2) }}% </h1> </div>
                  </th>
                  <th>
                    <b-field>
                      <ValidationProvider
                        :name="`errors-input`"
                        :rules="`integer`"
                        v-slot="{ errors }">
                        <b-field
                          label="Errores" label-position="inside"
                          :type="{ 'is-danger': errors[0] }">
                          <b-input type="number" @blur="calcTotals" v-model="judgeResultsExecution.errors"></b-input>

                        </b-field>
                      </ValidationProvider>
                    </b-field>
                    <b-field label="Observación General" label-position="inside">
                      <b-input maxlength="250" type="textarea" v-model="judgeResultsExecution.observation"></b-input>
                    </b-field>
                  </th>
              </template>

              <section class="section" slot="empty">
                <div class="content has-text-grey has-text-centered">
                  <template v-if="isLoading">
                    <p>
                      <b-icon icon="dots-horizontal" size="is-large" />
                    </p>
                    <p>Cargando datos...</p>
                  </template>
                  <template v-else>
                    <p>
                      <b-icon icon="horseshoe" size="is-large" />
                    </p>
                    <p>No hay datos&hellip;</p>
                  </template>
                </div>
              </section>
            </b-table>
          </ValidationObserver>
        </div>
    </card-component>
</template>

<script>

import CardComponent from '@/components/CardComponent'
import ExerciseService from '@/services/ExerciseService'
import ExecutionService from '@/services/ExecutionService'

export default {
  props: {
    lessonId: {
      required: true
    },
    executionId: {
      required: true
    },
    lesson: {
      required: true
    },
    resultExecution: {
      required: true
    },
    judge: {
      required: false
    }
  },
  components: {
    CardComponent
  },
  created () {
    if (this.judge) {
      this.mapExercisesResults()
    }
  },
  data () {
    return {
      isLoading: false,
      exercises: [],
      defaultOpenedDetails: [],
      judgeResultMap: [],
      totalJudgeResults: [],
      totalBaseJudgeResults: [],
      total: 0,
      allErrors: 0,
      finalScore: 0,
      onlyOfficials: true,
      componentKey: 0,
      subTotal: 0,
      judgeResultsExecution: {
        observation: null
      },
      numbers: '1,1.5,2,2.5,3,3.5,4,4.5,5,5.5,6,6.5,7,7.5,8,8.5,9,9.5,10'
    }
  },
  methods: {
    cancel () {
      this.$buefy.dialog.confirm({
        title: 'Cancelar edición Notas',
        message: '¿Estas seguro de querer <b>cancelar</b> la edición? <br> Los cambios realizados se perderán.',
        confirmText: 'Confirmar',
        cancelText: 'Cerrar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$emit('update:judge', null)
        }
      })
    },
    toggleDetails (row) {
      let id = row.id
      let searchedRow = this.defaultOpenedDetails.find(x => x.id === id)
      if (searchedRow) {
        this.defaultOpenedDetails = []
      } else {
        this.defaultOpenedDetails = [row]
      }
    },
    async mapExercisesResults () {
      this.isLoading = true
      let exectisesComplete = await this.getExercises()
      // let exercisesResults = executionResults.exercises
      this.judgeResultsExecution = await this.getJudgesResultsExecutions()

      let judgeResultsExercises = await this.getJudgesResultsExercises()

      let mapExercises = exectisesComplete.map((exercise, index) => {
        let result = {
          base_score: null,
          coefficient: parseInt(exercise.coefficient),
          execution_id: null,
          id: null,
          judge_id: this.judgeId,
          observation: null,
          official: null,
          order: exercise.order,
          status_id: 2,
          total_score: null,
          user_id: 1
        }
        let judgeResult = judgeResultsExercises.find((x) => x.order === exercise.order)

        if (judgeResult) {
          result = judgeResult
        }
        // console.log(judgeResult)
        // console.log(result)
        return {
          ...exercise,
          'result': {
            ...result
          }
        }
      })
      this.exercises = mapExercises
      this.calcTotals()
      this.forceRerender()
      this.isLoading = false
    },
    async getExercises () {
      if (this.lessonId == null) {
        return []
      }
      let params = {
        'include[0]': 'actionsPositions.action',
        'include[1]': 'actionsPositions.position'
      }
      let response = await ExerciseService.getExercises(this.lessonId, params)
      return response.data.data
    },
    async getJudgesResultsExercises () {
      let params = {
        'judge_id': this.judgeId
      }
      let response = await ExecutionService.getJudgesResultsExercises(this.executionId, params)
      return response ? response.data.data : []
    },
    async getJudgesResultsExecutions () {
      let params = {
        'judge_id': this.judgeId
      }
      let response = await ExecutionService.getJudgesResultsExecutions(this.executionId, params)
      return response ? response.data.data[0] : null
    },
    async updateJudgeResultExecution (resultExecutionId, data) {
      let response = await ExecutionService.updateJudgeResultExecution(this.executionId, resultExecutionId, data)
      return response
    },
    async updateJudgesResultsExercisesList (resultsList, judgeId) {
      let data = {
        list: resultsList
      }
      let response = await ExecutionService.updateJudgesResultsExercisesList(this.executionId, judgeId, data)
      return response
    },
    forceRerender () {
      this.componentKey++
    },
    calcTotals () {
      let subtotal = 0
      for (let index = 0; index < this.exercises.length; index++) {
        let exercise = this.exercises[index]
        if (exercise && !exercise.disabled_evaluate) {
          let result = exercise.result
          subtotal += (parseFloat(result.base_score) * parseInt(result.coefficient))
        }
      }
      const levelId = this.lesson.level_id;

      const errors = this.exerciseErrors && this.exerciseErrors !== ''  ? parseInt(this.exerciseErrors) : 0;
      this.subTotal = subtotal
      if (levelId === 3) {
        this.total = subtotal
        const score = (subtotal / parseInt(this.lesson.max_score) * 100)
        this.finalScore = errors  && errors === 1 ? score - 2 : score;
      } else {
        const discount =   errors && errors > 0 ? ((errors + (errors - 1)) * 2) : 0;
        this.total = subtotal - discount;
        this.finalScore = (this.total / parseInt(this.lesson.max_score) * 100)
      }
      
      
      
      // this.forceRerender()
    },
    async saveChages () {
      if (await this.$refs.observer.validate()) {
        this.$buefy.dialog.confirm({
          title: 'Edición Notas',
          message: '¿Estas seguro de querer <b>editar</b> las notas? <br> Una vez modificadas no se podrá volver a su estado original.',
          confirmText: 'Actualizar',
          cancelText: 'Cerrar',
          type: 'is-warning',
          hasIcon: true,
          onConfirm: async () => {
            let data = {
              observation: this.judgeResultsExecution.observation,
              errors: this.exerciseErrors
            }
            await this.updateJudgeResultExecution(this.judgeResultsExecution.id, data)
            await this.updateJudgesResultsExercisesList(this.mapScores, this.judgeId)
            this.success()
            this.$emit('update:judge', null)
            this.$emit('saved')
          }
        })
      } else {
        this.danger()
      }
    },
    success () {
      this.$buefy.toast.open({
        message: '¡Notas actualizadas correctamente!',
        type: 'is-success'
      })
    },
    danger () {
      this.$buefy.toast.open({
        duration: 5000,
        message: `Por favor asegúrese que las notas sean válidas`,
        position: 'is-bottom',
        type: 'is-danger'
      })
    }
  },
  computed: {
    exerciseErrors () {
      return this.judgeResultsExecution.errors ? this.judgeResultsExecution.errors : 0
    },
    judgeName () {
      return this.judge ? `${this.judge.name} ${this.judge.lastname}` : ''
    },
    judgeId () {
      return this.judge ? this.judge.id : null
    },
    mapScores () {
      return this.exercises.filter((x) => x.result !== null).map((exercise) => {
        return {
          'exercise_id': exercise.id,
          'observation': exercise.result.observation,
          'base_score': parseFloat(exercise.result.base_score),
          'status_id': exercise.status_id
        }
      })
    }
  },
  watch: {
    lessonId () {
      this.mapExercisesResults()
    },
    executionId () {
      this.mapExercisesResults()
    },
    lesson () {
      this.mapExercisesResults()
    },
    judgeId (value) {
      if (value) {
        this.mapExercisesResults()
      }
    }
  }
}
</script>

<style>
  .table-footer{
    padding: 0.5rem 2rem !important;
  }

  .selected-rows tbody tr{
    cursor: pointer !important;
  }

  .totalScore {
    font-weight: 600;
  }

  .ft-totals{
    text-align: right;
    width: 100%;
  }
  .ft-labels{
    font-size: 0.7rem;
  }
</style>
